import { render, staticRenderFns } from "./IntroSectionText.vue?vue&type=template&id=6993567a&scoped=true&"
import script from "./IntroSectionText.vue?vue&type=script&lang=js&"
export * from "./IntroSectionText.vue?vue&type=script&lang=js&"
import style0 from "./IntroSectionText.vue?vue&type=style&index=0&id=6993567a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6993567a",
  null
  
)

export default component.exports